import { log } from '@ms-ows/logging'

import { ActionType, MultiSurfaceParams, SurfaceParams } from '../models'
import { fetchURL } from '../utils'

import { getPageContext } from './state'

const SERVICE_ACTION_URL =
  'https://messaging.action.office.com/setcampaignaction'

// standard IRIS actions - https://osgwiki.com/wiki/Iris_Insights_Beacons#Standard_Iris_actions
export type BeaconAction =
  // standard
  | 'click'
  | 'conversion'
  | 'hover'
  // extended
  | 'click1'
  | 'click2'
  | 'click3'
  | 'dismiss'
  // Impressions
  | 'AASHOWED'
  | 'SHOWED'
  | 'CONTROLSHOWED'

type DummyBeaconAction = 'impression'

const performBeaconRequestCallback = (
  actionName: BeaconAction | DummyBeaconAction,
  actionUrl: string,
  surfaceParams: SurfaceParams | MultiSurfaceParams
) => {
  try {
    if (actionName && actionUrl) {
      const pageContext = getPageContext()
      let hostBeaconCallSucceeded = false
      try {
        if (pageContext && pageContext.beaconCallback) {
          pageContext.beaconCallback({
            actionName,
            actionUrl,
          })
          hostBeaconCallSucceeded = true
        }
      } catch (error) {
        log.warn(
          0x234e04a0 /* tag_9t6s6 */,
          'pageContext.beaconCallback call failed. Sending POST request to SetCampaignAction endpoint with actionName and actionUrl',
          error
        )
      }

      if (!hostBeaconCallSucceeded) {
        const fallbackUrl = surfaceParams.actionUrl || SERVICE_ACTION_URL
        const options = {
          body: JSON.stringify({
            actionName: encodeURIComponent(actionName),
            actionUrl: encodeURIComponent(actionUrl),
          }),
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
          method: 'POST',
        }
        fetchURL(`Beacon-${actionName}`, fallbackUrl as string, options)
      }
    } else {
      log.warn(
        0x23602893 /* tag_9yc8t */,
        'actionName or actionUrl were undefined for beacon callback',
        actionName,
        actionUrl
      )
    }
  } catch (error) {
    log.error(
      0x23602894 /* tag_9yc8u */,
      'failed to perform beacon callback',
      error
    )
  }
}

export const getBeaconAction = (
  actionName: ActionType
): BeaconAction | undefined => {
  switch (actionName) {
    case 'isAA':
      return 'AASHOWED'
    case 'isControl':
      return 'CONTROLSHOWED'
    case 'auto dismiss':
    case 'close':
      return 'dismiss'
    case 'primary':
      return 'click1'
    case 'secondary':
      return 'click2'
    case 'error':
    default:
      return undefined
  }
}

export const performBeaconCallback = (
  actionName: BeaconAction,
  surfaceParams: SurfaceParams | MultiSurfaceParams
) => {
  return performBeaconRequestCallback(
    actionName,
    surfaceParams.actionBeaconUrl as string,
    surfaceParams
  )
}

export const performActionBeaconCallback = (
  actionType: ActionType,
  surfaceParams: SurfaceParams | MultiSurfaceParams
) => {
  const actionName = getBeaconAction(actionType)
  if (!actionName) {
    return
  }

  return performBeaconRequestCallback(
    actionName,
    surfaceParams.actionBeaconUrl as string,
    surfaceParams
  )
}

export const performImpressionCallback = (
  surfaceParams: SurfaceParams | MultiSurfaceParams
) => {
  return performBeaconRequestCallback(
    'impression',
    surfaceParams.impressionBeaconUrl as string,
    surfaceParams
  )
}
